import { Component, Input, Output, EventEmitter } from '@angular/core'
import { environment } from 'src/env/environment'
import { Clipboard } from '@angular/cdk/clipboard'

@Component({
  selector: 'maglive-share-modal',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss'],
})
export class ShareModalComponent {
  @Input() live
  @Output() toggleShareModalEvent = new EventEmitter<void>()

  shareUrl: string
  encodeUrl: string
  scheduledAt: string
  shareText: string
  shareTag = encodeURIComponent('まぐまぐLive')
  isShowToast = false
  private TOAST_SHOW_TIME = 3000

  constructor(private clipboard: Clipboard) {}

  ngOnInit() {
    this.shareUrl = location.href
    this.encodeUrl = encodeURIComponent(location.href)
    this.scheduledAt = this.convertDate()
    this.shareText = encodeURIComponent(`【${this.scheduledAt}開始予定】 ${this.live.title}`)
  }

  toggleShareModal(): void {
    this.toggleShareModalEvent.emit()
  }

  convertDate() {
    if (typeof this.live === 'string') {
      return null;
    }
    if (this.live.scheduledAt === null) {
      return null;
    }
    const date = this.live.scheduledAt.toDate()
    return date.getFullYear() + '/' + (date.getMonth() + 1) + "/" + date.getDate() + " " + date.getHours() + ":" + ('00' + date.getMinutes()).slice(-2)
  }

  /**
   * クリップボードにライブURLをコピーする
   */
  copyClipboad(): void {
    this.clipboard.copy(this.shareUrl)
    this.isShowToast = true;
    const timer = setTimeout(() => {
      this.isShowToast = false
    }, this.TOAST_SHOW_TIME)
  }
}
